export default __webpack_public_path__ + "valid-records-light-icon.svg";